<template>
  <div id="fixed-right-service">

    <template v-if="User.isLogin()">
      <login-service-list></login-service-list>
    </template>

    <template v-else>
      <no-login-service-list></no-login-service-list>
    </template>

    <scroll-top-btn class="back-to-top"></scroll-top-btn>

  </div>
</template>

<script>
import { mapActions } from 'vuex';
import User from '@/libs/user';
import LoginServiceList from './components/login-service-list.vue';
import NoLoginServiceList from './components/no-login-service-list.vue';
import scrollTopBtn from './components/scroll-top-btn.vue';


export default {
  props: {},
  components: {
    LoginServiceList,
    NoLoginServiceList,
    scrollTopBtn,
  },
  data() {
    return {
      User,
    };
  },
  computed: {
  },
  mounted() {
    if (navigator.platform.indexOf('Mac') > -1) {
      document.body.classList.add('mac');
    }
    if (User.isLogin()) {
      this.getPeerCSData();
      this.getPeerBdData();
    }
  },
  methods: {
    ...mapActions('user', ['getPeerCSData', 'getPeerBdData']),

  },
};
</script>

<style lang="less" scoped>
#fixed-right-service {
  position: fixed;
  top: 30%;
  right: 21px;
  z-index: 1006; // 因为详情页的product-right-fixed的z-index为1005
  .back-to-top{
    margin-top: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/fixed-right-service.vue